import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { TableProperty } from '@/components/admin/Property/TableProperty';
import { Button } from '@/components/common/Button';

export const Property: React.FC = () => {
  return (
    <AdminLayout>
      <div className="flex justify-between items-start h-16 mb-6">
        <h2 className="text-xl font-bold">物件情報一覧</h2>
        <div></div>
      </div>
      <div className="bg-white pt-6 shadow-lg">
        <TableProperty />
      </div>
    </AdminLayout>
  );
};
